
import { Component, Mixins } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { ScaleMixin, RouteMixin } from '@/mixins';
import { OnlinePortalUser } from '@sageworks/jpi';

@Component({
	validations: {
		firstName: {
			required
		},
		lastName: {
			required
		}
	}
})
export default class MyInfoUpdated extends Mixins(ScaleMixin, RouteMixin) {
	private firstName?: string = '';
	private lastName?: string = '';
	private email?: string = '';
	private submitting: boolean = false;
	private failedToSaveFeedback: string | null = null;
	private validationMessages: Map<string, string> = new Map([
		['firstName', 'This field is required'],
		['lastName', 'This field is required']
	]);
	private showValidation: boolean = false;
	private auth0FFEnabled: boolean = false;

	private async created() {
		this.auth0FFEnabled = await this.directStore.dispatch.Authentication.isAuth0Enabled();
		await this.directStore.dispatch.User.loadCurrentUser();
		this.firstName = this.directStore.state.User.user!.firstName || '';
		this.lastName = this.directStore.state.User.user!.lastName || '';
		this.email = this.directStore.state.User.user!.email || '';
		if (this.auth0FFEnabled) {
			// this is a hack to disable back button so auth0 errors won't appear
			history.pushState(null, null, location.href);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			window.onpopstate = function(event) {
				history.go(1);
			};
		}
	}

	private validationState(fieldName: string) {
		if (!this.showValidation) {
			return null;
		} else if (this.$v[fieldName].$invalid) {
			return false;
		}
		return true;
	}

	private async submit(): Promise<void> {
		if (this.$v.$invalid) {
			this.showValidation = true;
			return;
		}

		this.submitting = true;
		try {
			this.showValidation = true;
			this.failedToSaveFeedback = null;
			await this.directStore.dispatch.User.patchCurrentUser({
				firstName: this.firstName,
				lastName: this.lastName
			} as OnlinePortalUser);
		} catch (err) {
			this.showValidation = false;
			this.failedToSaveFeedback = 'Unable to save these changes. Please try again.';
		}
		this.submitting = false;
	}
}
